export enum CollectionActionUiEnum {
  DUPLICATE = 'DUPLICATE',
  DELETE = 'DELETE',
  EDIT = 'EDIT',
}
